import { ReactNode } from "react";

interface OptionProps {
    icon: ReactNode;
    text: string;
    onClick?: () => void;
}

export const Option = ({ icon, text, onClick }: OptionProps) => {
    return (
        <div className="flex flex-col items-center justify-between h-full" onClick={onClick}>
            <div>{icon}</div>
            <div>{text}</div>
        </div>
    );
};
